import ClockView from './clock-view'

export default ClockView
